import { render, staticRenderFns } from "./Taxonomizado.vue?vue&type=template&id=4ab28f8b&"
import script from "./Taxonomizado.vue?vue&type=script&lang=js&"
export * from "./Taxonomizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports